import { combineEpics } from "redux-observable";
import updateUserData from "./update-user-data/observables";
import getNovelties from "./novelties/observables";
import campaings from "./campaigns/observables";
import equity from "./equity/observables";

export default combineEpics(updateUserData, campaings, equity, getNovelties);
